<template>
  <div>
    <Board class="mb-6">
      <template #header class="mb-6">
        <div class="w_header">
          <BaseTitle v-text="$t('workflow.operation.AutomatedOperation')" />
        </div>
      </template>
      <template #main>
        <BaseDivider class="my-5" :grey="true" />
        <div class="d-flex">
          <BaseButton
            class="ml-auto"
            icon="$mdiPlus"
            @click="operationModalOpen = !operationModalOpen"
          >
            {{ $t("workflow.operation.createAutomatedOperation") }}
          </BaseButton>
        </div>
        <div class="effect_list">
          <BaseDataTable
            :items="wfOperationsDetails.items"
            :loading="wfOperations.loading"
            :loading-text="$t('utils.loadingData')"
            hide-default-footer
          >
            <template #header>
              <thead>
                <tr>
                  <th>{{ $t("utils.label") }}</th>
                  <th>{{ $t("cosmoform.dialog.concernedFields") }}</th>
                  <th>{{ $t("workflow.operation.result") }}</th>
                  <th class="text-end">
                    {{ $t("utils.actions") }}
                  </th>
                </tr>
              </thead>
            </template>
            <template #item="{ item }">
              <tr v-if="item" class="tab_row">
                <td>
                  <div class="row_item">
                    <div class="item_label" v-text="item.label" />
                  </div>
                </td>

                <td>
                  <div class="row_item">
                    <div
                      class="item_label"
                      v-text="
                        `${item.firstOperator.name}, ${item.secondOperator.name}`
                      "
                    />
                  </div>
                </td>

                <td>
                  <div class="row_item">
                    <div
                      class="item_label"
                      v-text="`${item.resultField.name}`"
                    />
                  </div>
                </td>
                <td>
                  <div class="action_section">
                    <BaseIcon
                      color="primary"
                      icon="$mdiEdit"
                      class="mr-2"
                      @click="openEditModal(item)"
                    />
                    <BaseIcon
                      color="secondary"
                      icon="$mdiDelete"
                      @click="openDeleteModal(item)"
                    />
                  </div>
                </td>
              </tr>
            </template>
          </BaseDataTable>
        </div>
      </template>
    </Board>
    <OperationCreateAndEditDialog
      v-if="operationModalOpen"
      :organization-id="organizationId"
      :selected-operation="selectedOperation"
      @operation-created="operationCreated"
      @operation-edited="editOperation"
      @close="closeModal"
    />
    <OperationDeleteDialog
      v-if="deleteDialogOpen"
      :organization-id="organizationId"
      :selected-operation="selectedOperation"
      @close="closeDeleteModal"
      @operation-deleted="operationDeleted"
    />
  </div>
</template>

<script>
import workflowApi from "../Services/workflow.api";
import Board from "@/core/Components/Board.vue";
import OperationCreateAndEditDialog from "./OperationCreateAndEditDialog.vue";
import { Operation } from "@/core/Models/Operation";
import OperationDeleteDialog from "./OperationDeleteDialog.vue";

export default {
  name: "AutomatedOperationManagement",
  components: {
    Board,
    OperationCreateAndEditDialog,
    OperationDeleteDialog,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
    operations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      removeOperationDialog: false,
      selectedOperations: null,
      wfOperationsToEdit: null,
      wfOperationsDetails: {
        items: [],
      },
      wfOperations: {
        page: 1,
        pageSize: 15,
        loading: false,
      },
      selectedOperation: null,
      operationModalOpen: false,
      deleteDialogOpen: false,
    };
  },
  created() {
    this.wfOperationsDetails.items = this.operations;
  },
  methods: {
    openEditModal(item) {
      this.selectedOperation = { ...item };
      this.operationModalOpen = true;
    },
    openDeleteModal(item) {
      this.selectedOperation = { ...item };
      this.deleteDialogOpen = true;
    },
    closeModal() {
      this.operationModalOpen = false;
      this.selectedOperation = null;
    },
    editOperation({ id, data }) {
      const index = this.wfOperationsDetails.items.findIndex(
        (wfOp) => wfOp.id == id
      );
      this.wfOperationsDetails.items.splice(index, 1, data);
      this.selectedOperation = null;
    },
    operationCreated() {
      this.fetchWorkflowOperations();
      this.selectedOperation = null;
    },
    operationDeleted() {
      const index = this.wfOperationsDetails.items.findIndex(
        (wfOp) => wfOp.id == this.selectedOperation.id
      );
      this.wfOperationsDetails.items.splice(index, 1);
      this.$emit("updatedOperations", this.wfOperationsDetails.items);
      this.selectedOperation = null;
    },
    closeDeleteModal() {
      this.deleteDialogOpen = false;
      this.selectedOperation = null;
    },
    async fetchWorkflowOperations() {
      this.wfOperations.loading = true;
      try {
        const res = await workflowApi.getOrganizationWorkflowOperations({
          organizationId: this.organizationId,
          workflowId: this.workflow.id,
          params: {},
        });
        this.wfOperationsDetails = {
          ...res.data,
          items: res.data.results.map((d) => new Operation(d)),
        };
        this.$emit("updatedOperations", this.wfOperationsDetails.items);
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.wfOperations.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.w_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}
.inactivity_section {
  padding: 24px;
  background: #fff;
  margin-bottom: 24px;
  .header_section {
    display: flex;
    justify-content: space-between;
  }
  .alert_label {
    color: #353542;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    display: flex;
    gap: 4px;
    align-items: center;

    .days {
      font-weight: bold;
      color: #ff5267;
      line-height: 14px;
      padding: 4px 6px;
      border-radius: 4px;
      background: rgba(#ff5267, 0.2);
    }
  }
}
.automation_section {
  .action {
    display: flex;
    justify-content: flex-end;
    .menu-action {
      position: relative;
      .item_contain {
        position: absolute;
        z-index: 100;
        left: -14px;
        top: 30px;
        border-radius: 5px;
        width: calc(100% + 30px);
        background: #fff;
        box-shadow: 0px 6px 10px 0px rgba(46, 45, 193, 0.06),
          0px 2px 4px 0px rgba(46, 45, 193, 0.1);
        .item-list {
          padding: 12px;
          height: 45px;
        }
      }
    }
  }
}
.effect_list {
  padding-top: 16px;
  .tab_row {
    .row_item {
      padding: 16px 0;
      font-family: "Inter";
      font-style: normal;
      .item_label {
        color: #353542;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
      }
      .item_extra {
        color: #707080;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-transform: uppercase;
      }
      .item_link {
        color: #2536cc;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-decoration: underline;
        cursor: pointer;
      }
      .unique_input {
        width: 18px;
        height: 18px;
      }
    }
    .action_section {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;
    }
  }
}

// new
.item-list {
  display: flex;
  align-items: center;
  height: 33px;
  cursor: pointer;
  &:hover {
    background: #f4f7ff;
  }
}
</style>
